import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import QuoteCategoriesView from './QuoteCategories';

const QuotersView = () => (
  <Routes>
    <Route path="categories/:tab" element={<QuoteCategoriesView />} />
    <Route path="categories" element={<QuoteCategoriesView />} />
    <Route index element={<Navigate to="categories/QUOTE_CATEGORIES" replace />} />
  </Routes>
);

export default QuotersView;
